import React, {useState} from "react";
import { Box, Table, Title } from "@allxsmith/bestax-bulma";
import SalesPrepRow from "./SalesPrepRow";
import FilterBlankHeading from "../Invoicing/FilterBlankHeading";
import FilterHeading from "../Invoicing/FilterHeading";
import axios from "axios";
import {createSetDataFreshAction} from "../../actions/dataActions";
import {toast, ToastContainer} from "react-toastify";
import {useDispatch} from "react-redux";



export default function SalesPrepVehicles({endpoint, data, filters, setFilters, dataFresh}){
    const dispatch = useDispatch();

  const filter = (vehicle) =>{
    return vehicle.sales_prep
  }

  const onSave = (e, value, setEditable) => {
    e.preventDefault();
    const url = endpoint + "vehicles/" + value.id;

    const conf = {
      method: "put",
      data: value,
      url
    };

    axios(conf)
      .then(response => {
        if (response) {
          dispatch(createSetDataFreshAction(dataFresh + 1));
          setEditable(false);
        }
      })
      .catch(err => {
        if (err.response.data) {
          toast.error(
            JSON.stringify(err.response.data), {position: "top-right"}
          );
        }
      });
  };

  const headings = [
      {
          label: "Department",
          field: "department",
          labelField: "department__name"
      },
      {
          label: "Registration"
      },
      {
          label: "Make"
      },
      {
          label: "Model"
      },
      {
          label: "Location"
      }
  ]

  return (
    <Box>
      <Title size="5">Sales Prep Vehicles</Title>
      <Table>
        <thead>
          <tr className={"small-row-black"}>
            {headings.map(heading => {
                if (!heading.field) {
                  return <th key={heading.label} className={heading.className || ""}>{heading.label}</th>;
                }
                if (heading.blank) {
                  return (
                    <FilterBlankHeading
                      key={heading.label}
                      heading={heading}
                      setFilters={f => {
                        setFilters(f);
                      }}
                      filters={filters}
                      className={heading.className}
                      thClass={heading.thClass}
                    />
                  );
                }
                return (
                  <FilterHeading
                    key={heading.label}
                    heading={heading}
                    setFilters={f => {
                      setFilters(f);
                    }}
                    filters={filters}
                    options={data.filter_list[heading.field]}
                    className={heading.className}
                    thClass={heading.thClass}
                  />
                );
              })}
          </tr>
        </thead>
        <tbody>
          {data.results.filter(filter).map((value, index) => (
            <SalesPrepRow
              key={value.id}
              value={value}
              index={index}
              onSave={onSave}
            />
          ))}
        </tbody>
      </Table>
    </Box>
  );

}